import { Gap, Heading } from '@salecycle/ui-component-library';
import { FC } from 'react';
import { Trans, useTranslation } from 'react-i18next';

interface IHeadingProps {
  listType: string;
}

export const BlocklistAllowlistHeading: FC<IHeadingProps> = ({ listType }: IHeadingProps) => {
  const { t } = useTranslation();

  return (
    <div data-test-id="BlocklistAllowlistHeading">
      {listType === 'allowlist' ? (
        <>
          <Heading variation="h1">
            <Trans t={t} i18nKey={`settings.${listType}.productHeadingNew`} />
          </Heading>
          <Gap bottom={15} />
          <Trans t={t} i18nKey={`settings.${listType}.descriptionNew`} />
          <Gap bottom={5} />
          <Trans t={t} i18nKey={`settings.${listType}.reminder`} />
          <Gap bottom={30} />
        </>
      ) : (
        <>
          <Heading variation="h1">{t(`settings.${listType}.productHeading`)}</Heading>
          <Gap bottom={30} />
          <Heading variation="h2">{t(`settings.${listType}.heading`)}</Heading>
          {t(`settings.${listType}.description`)}
          <Gap bottom={30} />
        </>
      )}
    </div>
  );
};
export default BlocklistAllowlistHeading;
